<template>
  <div v-if="doctor">
    <div class="col-12 p-0" style="border-bottom: 1px solid #0000001f">
      <div class="row">
        <div class="col-3 col-lg-1 text-center">
          <n-button type="primary" round icon @click.native="getSlotsForPreviousDay()" :disabled="days.indexOf(selectedDay) == 0">
            <i class="fa fa-chevron-left"></i>
          </n-button>
        </div>
        <div class="col-6 col-lg-10 text-center" style="white-space: nowrap; overflow: scroll" ref="day-selector">
          <span :id="day.date.getTime()" v-for="day in days" :key="day.date.getTime()" class="ml-3 mr-3 pb-1" @click="selectDay(day)" style="line-height: 65px; cursor: pointer" :style="
              selectedDay == day
                ? { borderBottom: '3px solid var(--color-primary)', fontWeight: 'bold' }
                : {}
            ">{{ getDay(day) }}</span>
        </div>
        <div class="col-3 col-lg-1 text-center">
          <n-button type="primary" round icon @click.native="getSlotsForNextDay()" :disabled="days.indexOf(selectedDay) == days.length - 1">
            <i class="fa fa-chevron-right"></i>
          </n-button>
        </div>
      </div>
    </div>
    <div class="col-sm-12" id="slots-container">
      <div style="margin-top: 1em; display: block">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group providers-slots" style="clear: both" v-show="slots.length > 0" :id="doctor._id">
              <div v-loading="LOADING_SLOTS">
                <div id="slots-container" v-if="slots.length > 0" style="padding-left: 0px; padding-right: 0px">
                  <!-- Morining Slots -->
                  <div class="row" style="padding-left: 0px" id="morning" v-show="hasMorningSlots()">
                    <div class="col-2 col-lg-2 mt-2">
                      <img src="@/assets/img/sun-mor.png" style="width: 20px" />
                      <span translate style="
                          color: grey;
                          font-size: 0.9em;
                        "> {{ $t("message.Morning") }}</span>
                    </div>
                    <div class="col-10 col-lg-10">
                      <a class="btn slot-btn pl-1 pr-1" v-for="slot in slots" style="margin-right: 10px; margin-bottom: 10px" @click="selectSlot(slot, $event)" v-if="isMorning(slot.start)" :class="checkForAvailibility(slot, doctor._id)">{{ getFormattedTimeForView(slot.start) }}</a>
                    </div>
                  </div>

                  <!--Afternoon Slot -->
                  <div class="row" style="margin-top: 20px; padding-left: 0px" id="after" v-show="hasAfternoonSlots()">
                    <div class="col-2 col-lg-2 mt-2">
                      <img src="@/assets/img/sun-noon.png" style="width: 20px" />
                      <span translate style="
                          color: grey;
                          font-size: 0.9em;
                          padding-left: 0em;
                          margin-left: -0.7em;
                        ">{{ $t("message.Afternoon") }}</span>
                    </div>
                    <div class="col-10 col-lg-10">
                      <a class="btn slot-btn pl-1 pr-1" v-for="slot in slots" style="margin-right: 10px; margin-bottom: 10px" @click="selectSlot(slot, $event)" v-if="isAfternoon(slot.start)" :class="checkForAvailibility(slot, doctor._id)">{{ getFormattedTimeForView(slot.start) }}</a>
                    </div>
                  </div>

                  <div class="row" style="margin-top: 20px; padding-left: 0px" v-show="hasEveningSlots()">
                    <div class="col-2 col-lg-2 mt-2">
                      <img src="@/assets/img/sunset.png" style="width: 20px" />
                      <span translate style="
                          color: grey;
                          font-size: 0.9em;
                          padding-left: 0em;
                          margin-left: -0.7em;
                        ">{{ $t("message.Evening") }}</span>
                    </div>
                    <div class="col-10 col-lg-10">
                      <a class="btn slot-btn pl-1 pr-1" v-for="slot in slots" style="margin-right: 10px; margin-bottom: 10px" @click="selectSlot(slot, $event)" v-if="isEvening(slot.start)" :class="checkForAvailibility(slot, doctor._id)">{{ getFormattedTimeForView(slot.start) }}</a>
                    </div>
                  </div>
                  <div class="row" style="margin-top: 20px; padding-left: 0px" v-show="hasNightSlots(doctor.availableSlots)">
                    <div class="col-2 col-lg-2 mt-2">
                      <img src="@/assets/img/moon.png" style="width: 20px" />
                      <span translate style="
                          color: grey;
                          font-size: 0.9em;
                          padding-left: 0em;
                          margin-left: -0.7em;
                        ">{{ $t("message.Night") }}</span>
                    </div>
                    <div class="col-10 col-lg-10">
                      <a class="btn slot-btn pl-1 pr-1" v-for="slot in slots" style="margin-right: 10px; margin-bottom: 10px" @click="selectSlot(slot, $event)" v-if="isNight(slot.start)" :class="checkForAvailibility(slot, doctor._id)">{{ getFormattedTimeForView(slot.start) }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center" style="padding: 20px; width: 100%" v-show="slots.length < 1" v-loading="LOADING_SLOTS">
        <p class="alert-text" style="margin-bottom: 0px; font-size: x-large">
          <i>{{ $t("message.No slots available on this day") }}</i>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "slot-selection",

  data() {
    return {
      days: [],
      selectedDay: null,
      slots: [],
      doctor: null,
      LOADING_SLOTS: false,
    };
  },

  props: ["doctorId"],

  async mounted() {
    this.days = [
      {
        date: new Date(),
        formattedDate: moment(new Date()).format("ddd, Do MMM"),
      },
      {
        date: new Date(new Date().setDate(new Date().getDate() + 1)),
        formattedDate: moment(
          new Date(new Date().setDate(new Date().getDate() + 1))
        ).format("ddd, Do MMM"),
      },
      {
        date: new Date(new Date().setDate(new Date().getDate() + 2)),
        formattedDate: moment(
          new Date(new Date().setDate(new Date().getDate() + 2))
        ).format("ddd, Do MMM"),
      },
      {
        date: new Date(new Date().setDate(new Date().getDate() + 3)),
        formattedDate: moment(
          new Date(new Date().setDate(new Date().getDate() + 3))
        ).format("ddd, Do MMM"),
      },
      {
        date: new Date(new Date().setDate(new Date().getDate() + 4)),
        formattedDate: moment(
          new Date(new Date().setDate(new Date().getDate() + 4))
        ).format("ddd, Do MMM"),
      },
      {
        date: new Date(new Date().setDate(new Date().getDate() + 5)),
        formattedDate: moment(
          new Date(new Date().setDate(new Date().getDate() + 5))
        ).format("ddd, Do MMM"),
      },
      {
        date: new Date(new Date().setDate(new Date().getDate() + 6)),
        formattedDate: moment(
          new Date(new Date().setDate(new Date().getDate() + 6))
        ).format("ddd, Do MMM"),
      },
    ];

    this.selectedDay = this.days[0];
    this.doctor = await this.$store.dispatch("getUserById", this.doctorId);
    this.getSlots();
  },

  methods: {
    //Days
    getDay(day) {
      if (day.formattedDate == moment(new Date()).format("ddd, Do MMM")) {
        return "Today";
      } else {
        return day.formattedDate;
      }
    },
    selectDay(day) {
      this.selectedDay = day;
      this.getSlots();
    },

    //Slots
    async getSlots() {
      this.LOADING_SLOTS = true;
      let query = {
        type: "appointment",
        users: [this.doctor._id],
        tenant: this.doctor.tenant._id,
        dateStart: this.selectedDay.date.setHours(0, 0, 0, 0),
        dateEnd: this.selectedDay.date.setHours(23, 59, 59, 0),
        slotType:
          this.slotType == "InPerson"
            ? "Available-InPerson"
            : "Available-TeleConsult",
      };

      try {
        this.slots = [];
        this.slots = await this.$store.dispatch("getAvailableSlots", query);
      } catch (error) {
        console.error(error);
      }
      this.LOADING_SLOTS = false;
    },
    getSlotsForNextDay() {
      if (this.days.indexOf(this.selectedDay) != this.days.length - 1) {
        this.selectedDay = this.days[this.days.indexOf(this.selectedDay) + 1];
        document
          .getElementById(this.selectedDay.date.getTime())
          .scrollIntoViewIfNeeded();
        this.getSlots();
      }
    },
    getSlotsForPreviousDay() {
      if (this.days.indexOf(this.selectedDay) != 0) {
        this.selectedDay = this.days[this.days.indexOf(this.selectedDay) - 1];
        document
          .getElementById(this.selectedDay.date.getTime())
          .scrollIntoViewIfNeeded();
        this.getSlots();
      }
    },
    selectSlot(slot) {
      this.$emit("slot-selected", slot);
    },
    hasMorningSlots() {
      var hasSlots = false;

      this.slots.forEach(function (slot) {
        var time = moment(slot.start).format("H:mm");
        var hour = time.split(":")[0];

        if (hour > -1 && hour < 12 && !hasSlots) {
          hasSlots = true;
        }
      });

      return hasSlots;
    },
    hasAfternoonSlots(slotArray) {
      var hasSlots = false;

      this.slots.forEach(function (slot) {
        var time = moment(slot.start).format("H:mm");
        var hour = time.split(":")[0];

        if (hour > 11 && hour < 16 && !hasSlots) {
          hasSlots = true;
        }
      });

      return hasSlots;
    },
    hasEveningSlots(slotArray) {
      var hasSlots = false;

      this.slots.forEach(function (slot) {
        var time = moment(slot.start).format("H:mm");
        var hour = time.split(":")[0];

        if (hour > 15 && hour < 20 && !hasSlots) {
          hasSlots = true;
        }
      });

      return hasSlots;
    },
    hasNightSlots(slotArray) {
      var hasSlots = false;

      this.slots.forEach(function (slot) {
        var time = moment(slot.start).format("H:mm");
        var hour = time.split(":")[0];

        if (hour > 19 && !hasSlots) {
          hasSlots = true;
        }
      });

      return hasSlots;
    },

    isMorning(slot) {
      var time = moment(slot).format("H:mm");
      var hour = time.split(":")[0];

      if (hour > -1 && hour < 12) {
        return true;
      } else {
        return false;
      }
    },
    isAfternoon(slot) {
      var time = moment(slot).format("H:mm");
      var hour = time.split(":")[0];

      if (hour > 11 && hour < 16) {
        return true;
      } else {
        return false;
      }
    },
    isEvening(slot) {
      var time = moment(slot).format("H:mm");
      var hour = time.split(":")[0];

      if (hour > 15 && hour < 20) {
        return true;
      } else {
        return false;
      }
    },
    isNight(slot) {
      var time = moment(slot).format("H:mm");
      var hour = time.split(":")[0];

      if (hour > 19) {
        return true;
      } else {
        return false;
      }
    },
    checkForAvailibility(slot, userId) {
      var isFree = false;

      var user = slot.availability.users[userId];
      if (user.appointments == "free") {
        return "btn-success";
      } else return "d-none";
    },
    getFormattedTimeForView(time) {
      return moment(time).format("h:mm A");
    },
  },

  watch: {
    doctorId: async function () {
      this.doctor = await this.$store.dispatch("getUserById", this.doctorId);
      this.getSlots();
    },
  },
};
</script>

<style scoped>
.slot-btn {
  width: 80px !important;
}
.not-available {
  cursor: no-drop;
  pointer-events: none;
}
/deep/ .el-loading-mask {
  background: #fffc !important;
  top: -15px;
}
/deep/ .el-loading-spinner {
  top: 10%;
}
</style>
